import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="59.15901" cy="24.02269" />
				<path opacity="0.4" fill="#fc5959" d="M26.23757,45.05305c0,0-22.34688-8.48164-21.39511-26.79797
					c0.3261-6.27568,4.798-10.8621,11.00851-11.82134c6.86674-1.0606,12.14507,4.00397,12.14507,4.00397
					s5.85511-4.48605,12.57494-2.71944c6.07763,1.59777,10.05008,6.62299,9.72398,12.89867
					C49.34319,38.93327,26.23757,45.05305,26.23757,45.05305z" />
				<path opacity="0.4" fill="#fc5959" d="M92.08024,45.05186c0,0-23.11103-6.09929-24.07905-24.41477
					C67.66952,14.3617,71.63751,9.33297,77.71372,7.7298c6.71826-1.77256,12.49707,2.71253,12.49707,2.71253
					s5.35411-5.0735,12.22179-4.01898c6.21136,0.95374,10.68732,5.53618,11.01899,11.81157
					C114.41959,36.55041,92.08024,45.05186,92.08024,45.05186z" />
				<path fill="#f96e6e" d="M118.28235,15.82188c-0.41982-8.07487-6.23684-14.35554-14.47632-15.62813
					c-6.14431-0.94921-11.23079,1.80199-13.83345,3.64197c-2.79845-1.55458-8.18201-3.76714-14.20457-2.18479
					c-6.79716,1.78689-11.49865,6.94156-12.56061,13.35251c-0.5048,0.11177-1.0096,0.20041-1.51464,0.25934
					c-0.85473,0.09813-1.70958,0.15341-2.56467,0.14635c-0.85521-0.00122-1.71055-0.05333-2.56625-0.15414
					c-0.48301-0.05698-0.96613-0.13758-1.44926-0.23962C54.05451,8.59881,49.35131,3.43903,42.55001,1.65092
					c-6.02157-1.58429-11.40709,0.62972-14.20456,2.18479c-2.60266-1.83949-7.68233-4.59021-13.83442-3.64197
					C6.27252,1.46634,0.45549,7.74701,0.03568,15.82188C-0.43868,24.9458,3.82473,33.40882,12.3652,40.29681
					c6.23197,5.0261,12.54478,7.45294,12.8107,7.55375c0.34092,0.12955,0.70132,0.19481,1.06171,0.19481
					c0.25715,0,0.5143-0.03312,0.76658-0.09984c0.01607-0.00438,0.05552-0.01485,0.11616-0.03166
					c0.93192-0.25812,7.08402-2.05671,13.40755-6.15356c7.53244-4.87974,12.32343-11.10562,14.07915-18.20352
					c0.66503-0.17582,1.33031-0.30293,1.99583-0.38158c0.85448-0.10106,1.70921-0.15293,2.56419-0.15414
					c0.85497-0.00731,1.71019,0.04797,2.56577,0.14635c0.65845,0.07671,1.31716,0.20455,1.9761,0.38012
					c1.75389,7.10155,6.54537,13.33084,14.08025,18.21277c6.71996,4.35303,13.24999,6.11265,13.52467,6.18521
					c0.25228,0.06672,0.50943,0.09984,0.76658,0.09984c0.3604,0,0.72079-0.06526,1.06171-0.19481
					c0.26591-0.10081,6.57873-2.52766,12.8107-7.55375C114.49329,33.40882,118.75671,24.9458,118.28235,15.82188z M47.30629,20.46176
					c-0.72372,13.93913-16.825,20.07905-20.90602,21.4135c-0.24948-0.11056-0.54741-0.24644-0.88322-0.4052
					C20.58154,39.12455,7.15062,31.51235,7.831,18.41041c0.24546-4.7217,3.57281-8.26189,8.47715-9.0197
					c0.48702-0.075,0.96528-0.10909,1.4338-0.10909c4.59459,0,8.15279,3.28839,8.18201,3.31518
					c1.05782,1.01545,2.70688,1.10457,3.87964,0.22501c0.04773-0.03555,4.83615-3.56599,10.00641-2.20963
					C44.60915,11.87405,47.55175,15.74006,47.30629,20.46176z M91.90899,41.87477
					c-4.08711-1.3213-20.18036-7.40424-20.91966-21.39548c-0.24935-4.7217,2.69033-8.59063,7.48849-9.85592
					c0.83476-0.22062,1.65686-0.31267,2.45071-0.31267c4.10464,0,7.41933,2.47311,7.44855,2.49551
					c1.15815,0.89807,2.80721,0.81577,3.88159-0.18215c0.0448-0.04042,4.43777-4.05545,9.72003-3.2431
					c4.90434,0.75294,8.23559,4.29069,8.48495,9.0119C111.20004,32.3325,95.82661,40.12149,91.90899,41.87477z" />
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="31.35428" cy="12.73203" />
				<path opacity="0.4" fill="#FC5959" d="M13.90591,23.87812c0,0-11.84385-4.49527-11.33941-14.20293
					c0.17284-3.32611,2.54294-5.75691,5.83451-6.26531c3.63937-0.56212,6.43689,2.1221,6.43689,2.1221s3.10321-2.3776,6.66472-1.44131
					c3.22115,0.84682,5.32654,3.51018,5.15371,6.83629C26.15189,20.63463,13.90591,23.87812,13.90591,23.87812z" />
				<path opacity="0.4" fill="#FC5959" d="M48.79046,23.87812c0,0,11.84385-4.49527,11.33941-14.20293
					c-0.17283-3.32611-2.54294-5.75691-5.83451-6.26531c-3.63937-0.56212-6.43689,2.1221-6.43689,2.1221
					s-3.10321-2.3776-6.66471-1.44131c-3.22115,0.84682-5.32655,3.51018-5.15371,6.83629
					C36.54449,20.63463,48.79046,23.87812,48.79046,23.87812z" />
				<path fill="#F96E6E" d="M62.68964,8.38559c-0.2225-4.27968-3.30552-7.60844-7.67245-8.28291
					c-3.25648-0.50308-5.95232,0.95506-7.33173,1.93024C46.20229,1.209,43.349,0.03635,40.15705,0.87499
					c-3.60249,0.94705-6.09428,3.67903-6.65712,7.07683c-0.26754,0.05924-0.53509,0.10622-0.80276,0.13745
					c-0.45301,0.05201-0.90608,0.08131-1.35928,0.07757c-0.45326-0.00064-0.90659-0.02826-1.36012-0.0817
					c-0.25599-0.0302-0.51205-0.07292-0.76811-0.127c-0.56077-3.40077-3.05347-6.13546-6.65816-7.08316
					c-3.19143-0.83967-6.04576,0.33375-7.52842,1.15794C13.64368,1.058,10.95146-0.39988,7.69084,0.10268
					C3.32443,0.77716,0.24141,4.10591,0.01891,8.38559c-0.25141,4.83568,2.0082,9.32108,6.53464,12.97172
					c3.30294,2.66383,6.64873,3.95006,6.78967,4.00349c0.18069,0.06866,0.3717,0.10325,0.56271,0.10325
					c0.13629,0,0.27258-0.01755,0.40629-0.05292c0.00852-0.00232,0.02943-0.00787,0.06156-0.01678
					c0.49392-0.1368,3.75453-1.09005,7.106-3.26138c3.9922-2.58626,6.53142-5.88598,7.46195-9.64787
					c0.35247-0.09318,0.70506-0.16055,1.05779-0.20224c0.45288-0.05356,0.90588-0.08105,1.35902-0.0817
					c0.45314-0.00387,0.9064,0.02542,1.35986,0.07757c0.34898,0.04065,0.6981,0.10841,1.04734,0.20146
					c0.92957,3.76382,3.46904,7.06534,7.46253,9.65277c3.56158,2.3071,7.0225,3.2397,7.16808,3.27816
					c0.13371,0.03536,0.27,0.05292,0.40629,0.05292c0.19101,0,0.38202-0.03459,0.56271-0.10325
					c0.14094-0.05343,3.48673-1.33966,6.78967-4.00349C60.68145,17.70668,62.94106,13.22127,62.68964,8.38559z M25.07234,10.84473
					c-0.38357,7.38774-8.91725,10.6419-11.08019,11.34915c-0.13222-0.05859-0.29013-0.13061-0.46811-0.21476
					c-2.61582-1.24312-9.73421-5.27758-9.37361-12.22161c0.13009-2.5025,1.89359-4.3788,4.49289-4.78044
					c0.25812-0.03975,0.5116-0.05782,0.75991-0.05782c2.43513,0,4.32098,1.74285,4.33647,1.75704
					c0.56064,0.53819,1.43465,0.58542,2.05621,0.11925c0.0253-0.01884,2.56316-1.88998,5.3034-1.1711
					C23.64285,6.29325,25.20243,8.34223,25.07234,10.84473z M48.71177,22.19363c-2.16617-0.70029-10.69559-3.92425-11.08742-11.3396
					c-0.13216-2.5025,1.42587-4.55303,3.9689-5.22364c0.44242-0.11693,0.87813-0.16571,1.29887-0.16571
					c2.17546,0,3.93225,1.31075,3.94773,1.32262c0.61382,0.47598,1.48782,0.43236,2.05724-0.09654
					c0.02375-0.02142,2.35202-2.14939,5.15162-1.71884c2.5993,0.39906,4.36486,2.27406,4.49702,4.77631
					C58.93602,17.13622,50.78811,21.26439,48.71177,22.19363z" />
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="41.41131" cy="16.81588" />
				<path opacity="0.4" fill="#FC5959" d="M18.3663,31.53714c0,0-15.64282-5.93715-14.97657-18.75858
					c0.22827-4.39298,3.3586-7.60347,7.70596-8.27494C15.9024,3.7612,19.59723,7.3064,19.59723,7.3064
					s4.09858-3.14023,8.80245-1.90361c4.25434,1.11844,7.03506,4.63609,6.80679,9.02907
					C34.54023,27.25329,18.3663,31.53714,18.3663,31.53714z" />
				<path opacity="0.4" fill="#FC5959" d="M64.44023,31.53714c0,0,15.64282-5.93715,14.97658-18.75858
					c-0.22827-4.39298-3.3586-7.60347-7.70596-8.27494C66.90414,3.7612,63.2093,7.3064,63.2093,7.3064
					s-4.09858-3.14023-8.80245-1.90361c-4.25434,1.11844-7.03506,4.63609-6.80679,9.02907
					C48.2663,27.25329,64.44023,31.53714,64.44023,31.53714z" />
				<path fill="#F96E6E" d="M82.79765,11.07531C82.50378,5.4229,78.43185,1.02644,72.66422,0.13562
					C68.3632-0.52883,64.80267,1.39701,62.9808,2.685c-1.95891-1.08821-5.72741-2.637-9.94319-1.52935
					c-4.75801,1.25083-8.04906,4.85909-8.79243,9.34676c-0.35336,0.07824-0.70672,0.14029-1.06025,0.18154
					c-0.59831,0.06869-1.1967,0.10739-1.79527,0.10245c-0.59865-0.00085-1.19738-0.03733-1.79638-0.1079
					c-0.33811-0.03989-0.6763-0.09631-1.01448-0.16773c-0.74065-4.49159-4.03288-8.10343-8.79379-9.35511
					c-4.2151-1.109-7.98496,0.44081-9.94319,1.52935c-1.82186-1.28764-5.37763-3.21315-9.6841-2.54938
					C4.39076,1.02644,0.31885,5.4229,0.02498,11.07531c-0.33205,6.38674,2.65234,12.31086,8.63066,17.13246
					c4.36238,3.51827,8.78135,5.21706,8.96749,5.28763c0.23864,0.09069,0.49092,0.13637,0.7432,0.13637
					c0.18,0,0.36001-0.02318,0.5366-0.06989c0.01125-0.00307,0.03886-0.0104,0.08131-0.02216
					c0.65234-0.18068,4.95881-1.43969,9.38528-4.30749c5.27271-3.41582,8.6264-7.77394,9.85541-12.74247
					c0.46552-0.12307,0.93122-0.21205,1.39708-0.26711c0.59814-0.07074,1.19645-0.10705,1.79493-0.1079
					c0.59848-0.00511,1.19713,0.03358,1.79604,0.10245c0.46092,0.0537,0.92201,0.14319,1.38327,0.26609
					c1.22773,4.97108,4.58176,9.33159,9.85617,12.74894c4.70398,3.04712,9.27499,4.27885,9.46727,4.32965
					c0.17659,0.04671,0.3566,0.06989,0.5366,0.06989c0.25228,0,0.50456-0.04568,0.7432-0.13637
					c0.18614-0.07057,4.60511-1.76936,8.96749-5.28763C80.14531,23.38618,83.1297,17.46206,82.79765,11.07531z M33.11441,14.32323
					c-0.5066,9.75739-11.7775,14.05534-14.63422,14.98945c-0.17463-0.07739-0.38319-0.1725-0.61825-0.28364
					c-3.45485-1.64186-12.8565-6.97039-12.38024-16.14175C5.65352,9.5821,7.98267,7.10397,11.4157,6.5735
					c0.34092-0.0525,0.6757-0.07637,1.00366-0.07637c3.21621,0,5.70695,2.30187,5.72741,2.32062
					c0.74047,0.71081,1.89482,0.7732,2.71575,0.1575c0.03341-0.02489,3.38531-2.4962,7.00449-1.54674
					C31.22641,8.31184,33.28623,11.01804,33.11441,14.32323z M64.33629,29.31234c-2.86097-0.92491-14.12624-5.18296-14.64376-14.97684
					c-0.17455-3.30519,1.88322-6.01344,5.24194-6.89914c0.58433-0.15444,1.1598-0.21887,1.7155-0.21887
					c2.87325,0,5.19353,1.73118,5.21399,1.74686c0.8107,0.62865,1.96505,0.57104,2.71711-0.1275
					c0.03136-0.0283,3.10644-2.83882,6.80402-2.27017c3.43304,0.52706,5.76492,3.00348,5.93946,6.30833
					C77.84003,22.63275,67.07863,28.08504,64.33629,29.31234z" />
			</g>
		);
	}
}


function Heart(props) {
	const glasses = {
		Cat,
		Tortoise,
		Chicken,
	};

	const ThisHeart = glasses[props.petType.name] || Cat;

	if (_.isUndefined(ThisHeart)) {
		return null;
	}

	return <ThisHeart {...props} />;
}

export default Heart;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Glasses/Heart.js